import React from 'react';
import { FileText, Share2, Download } from 'lucide-react';
import BottomSheet from './BottomSheet';
import { canSharePdf, sharePdf, downloadPdf } from '../../utils/pdfDelivery';

/**
 * Shown on mobile once a PDF has been generated, so sharing/saving happens
 * on a fresh tap (required by iOS for navigator.share and downloads).
 *
 * pdf: { blob, filename } | null
 */
function PdfReadySheet({ pdf, onClose, title = 'PDF ready' }) {
  if (!pdf) return null;
  const shareable = canSharePdf(pdf.blob, pdf.filename);

  return (
    <BottomSheet open onClose={onClose} title={title}>
      <div className="flex items-center gap-3 p-3 rounded-xl bg-gray-50 mb-4">
        <FileText className="w-8 h-8 text-red-500 flex-shrink-0" />
        <div className="min-w-0">
          <p className="font-medium text-gray-900 truncate">{pdf.filename}</p>
          <p className="text-xs text-gray-500">{Math.max(1, Math.round(pdf.blob.size / 1024))} KB</p>
        </div>
      </div>
      <div className="space-y-2">
        {shareable && (
          <button
            type="button"
            onClick={async () => { await sharePdf(pdf.blob, pdf.filename); onClose(); }}
            className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-blue-600 text-white font-medium active:bg-blue-700"
          >
            <Share2 className="w-5 h-5" />
            Share…
          </button>
        )}
        <button
          type="button"
          onClick={() => { downloadPdf(pdf.blob, pdf.filename); onClose(); }}
          className={`w-full inline-flex items-center justify-center gap-2 py-3 rounded-xl font-medium ${
            shareable ? 'border border-gray-300 text-gray-700 active:bg-gray-50' : 'bg-blue-600 text-white active:bg-blue-700'
          }`}
        >
          <Download className="w-5 h-5" />
          Open / save
        </button>
      </div>
    </BottomSheet>
  );
}

export default PdfReadySheet;
